'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = playing;

var _actionTypes = require('../../actions/action-types');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function playing() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var id = action && action.communityContentIdSerialized;
  switch (action.type) {
    case _actionTypes.COMMUNITY_CONTENT_VIDEO_PLAY:
      var nextState = _extends({}, state[id], {
        isVideoComplete: false
      });
      nextState.players = (nextState.players || []).filter(function (x) {
        return x !== action.playerId;
      }).concat([action.playerId]);

      return _extends({}, state, _defineProperty({}, id, nextState));
    case _actionTypes.COMMUNITY_CONTENT_VIDEO_POSITION_UPDATE:
      var currentState = state[id] || {};

      var newState = state;
      var delta = action.positionMs - (currentState.positionMs || 0);
      // Only allow for a 500ms resolution of state to prevent over rendering
      // of everything that renders too much.
      if (delta < 0 || delta > 500) {
        newState = _extends({}, state, _defineProperty({}, id, _extends({}, currentState, {
          positionMs: action.positionMs
        })));
      }
      return newState;
    case _actionTypes.COMMUNITY_CONTENT_VIDEO_QUARTILES_UPDATED:
      return _extends({}, state, _defineProperty({}, id, _extends({}, state[id], {
        quartiles: action.quartiles
      })));
    case _actionTypes.COMMUNITY_CONTENT_VIDEO_STOP:
      var isVideoComplete = action.isVideoComplete || !action.shouldContinueVideo;
      var communityContentState = _extends({}, state[id], {
        isVideoComplete: isVideoComplete
      });

      // Remove all players if video is complete or just the current player
      // if we are going to continue playing somewhere else.
      communityContentState.players = (communityContentState.players || []).filter(function (x) {
        return x !== action.playerId && !isVideoComplete;
      });

      if (isVideoComplete) {
        communityContentState.positionMs = 0;
        communityContentState.quartiles = null;
      }

      return _extends({}, state, _defineProperty({}, id, communityContentState));
    default:
      return state;
  }
}